import { moduleActionContext } from '@/vuex'
import { Rule } from '@klarna/cbrms-policy-rules-manager-client-ts'
import { defineActions, defineModule, defineMutations } from 'direct-vuex'

export const rulePreviewActionContext = (context: any) => moduleActionContext(context, rulePreviewModule)

export interface RulePreviewState {
  ruleId: string | undefined
  rule: Rule | undefined
  comparedRule: Rule | undefined
}

const rulePreviewModule = defineModule({
  namespaced: true,

  state: {
    ruleId: undefined,
    rule: undefined,
    comparedRule: undefined,
  } as RulePreviewState,

  mutations: defineMutations<RulePreviewState>()({
    SET_PREVIEWED_RULE_ID(state: RulePreviewState, ruleId: string | undefined) {
      state.ruleId = ruleId
    },

    SET_PREVIEWED_RULES(state: RulePreviewState, { rule, comparedRule }: { rule?: Rule; comparedRule?: Rule }) {
      state.rule = rule
      state.comparedRule = comparedRule
    },
  }),

  actions: defineActions({
    async PREVIEW_RULE(ctx, ruleId: string | undefined): Promise<void> {
      const { commit, rootDispatch, rootState } = rulePreviewActionContext(ctx)
      commit.SET_PREVIEWED_RULE_ID(ruleId)

      if (!ruleId) {
        commit.SET_PREVIEWED_RULES({})
        return
      } else {
        const previewedRule = rootState.policy.currentPolicy.rules.find(r => r.id === ruleId)!
        const currentCommit = previewedRule.current_commit
        const latestReleaseCommit = previewedRule.latest_release_commit
        const latestCommit = previewedRule.latest_commit
        const branch = previewedRule.branch_name
        const comparedCommit = branch === 'release' ? latestReleaseCommit : latestCommit
        if (currentCommit === comparedCommit) {
          commit.SET_PREVIEWED_RULES({ rule: previewedRule })
        } else {
          const comparedRule = await rootDispatch.rule.GET_RULE({
            ruleId,
            branch,
          })
          commit.SET_PREVIEWED_RULES({ rule: previewedRule, comparedRule })
        }
      }
    },
  }),
})

export default rulePreviewModule
